import type { ErrorComponentProps } from "@tanstack/react-router"

import { StatusAlert } from "@/components/shared/status-alert"
import { Button } from "@/components/ui/button"

export function RouteErrorBoundary({ error, reset }: ErrorComponentProps) {
  return (
    <StatusAlert tone="danger">
      <div className="flex flex-col gap-2">
        <div>Something went wrong loading this page.</div>
        {error instanceof Error ? (
          <div className="text-xs opacity-80">{error.message}</div>
        ) : null}
        <div>
          <Button variant="outline" size="sm" onClick={() => reset()}>
            Retry
          </Button>
        </div>
      </div>
    </StatusAlert>
  )
}
